<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
            d="M8.11596 1.90186L5.7856 6.56257L7.33917 7.33936M22.098 14.4142L19.2269 10.0657L17.7775 11.0227M3.56396 21.0534L8.669 22.0981L9.01723 20.3963"
            class="stroke-(--icon-primary)"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M16.6603 8.11565H11.2228L12.491 7.00595L8.11562 1.90137H14.3299L15.8017 4.10907L17.437 2.67815L16.6603 8.11565Z"
            class="stroke-(--icon-secondary)"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M12.4436 18.7063L15.1624 13.9973L15.4893 15.6505L22.0976 14.4136L18.9905 19.7952L16.3427 19.9661L16.7642 22.0978L12.4436 18.7063Z"
            class="stroke-(--icon-secondary)"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M7.35463 11.1909L8.76197 16.4432L7.36184 15.5054L3.56361 21.0529L1.95524 15.0503L3.70678 13.0572L1.90137 11.848L7.35463 11.1909Z"
            class="stroke-(--icon-secondary)"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
